import { RegisterOptions } from 'react-hook-form'
import { FormValues } from './types'

export const FORM_VALIDATION_RULES: Record<keyof FormValues, RegisterOptions<FormValues>> = {
  first_name: {
    required: { value: true, message: 'This field is required' },
    maxLength: {
      value: 64,
      message: 'Max length is 64 characters',
    },
    minLength: {
      value: 1,
      message: 'Min length is 1 character',
    },
  },
  last_name: {
    required: { value: true, message: 'This field is required' },
    maxLength: {
      value: 64,
      message: 'Max length is 64 characters',
    },
    minLength: {
      value: 1,
      message: 'Min length is 1 character',
    },
  },
  username: {
    maxLength: {
      value: 32,
      message: 'Max length is 32 characters',
    },
    minLength: {
      value: 1,
      message: 'Min length is 1 character',
    },
    // VERA-837: matches the charset auto-generated usernames are built from
    // (generate-username.util.ts) — letters, numbers, dot, underscore, hyphen.
    pattern: {
      value: /^[a-zA-Z0-9._-]+$/,
      message: 'Only letters, numbers, and . _ - are allowed',
    },
  },
  birthday: {},
  phone: {},
  country: {},
  gender: {},
  email: {},
  current_password: {},
  new_password: {},
}

export const PASSWORD_VALIDATION_RULES = {
  current_password: {
    required: { value: true, message: 'Current password is required' },
    minLength: { value: 8, message: 'Min length is 8 characters' },
  },
  new_password: {
    required: { value: true, message: 'New password is required' },
    minLength: { value: 8, message: 'Min length is 8 characters' },
    pattern: {
      value: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()|_+\-={}\[\]\\\/><>,.:"';~`])[a-zA-Z0-9!@#$%^&*()|_+\-={}\[\]\\\/><>,.:"';~`]{8,}$/,
      message: 'Use at least 8 chars, 1 upper, 1 lower, 1 number, 1 symbol',
    },
  },
}

export const EMAIL_VALIDATION_RULES = {
  email: {
    required: { value: true, message: 'Email is required' },
    pattern: {
      value: /^(?:[a-zA-Z0-9_'^&amp;+%$#!?`{}~\-]+\.)*[a-zA-Z0-9_'^&amp;+%$#!?`{}~\-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
      message: 'Enter a valid email',
    },
    maxLength: { value: 254, message: 'Max length is 254 characters' },
  },
}
